import { Trans } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import { Text } from 'designSystem/components/Text'
import type { ReactElement } from 'react'
import styled from 'styled-components'

type StatusPlacement = 'start' | 'center'

const Status = styled(Box)<{ $placement: StatusPlacement }>`
  position: absolute;
  top: 0.75rem;
  left: ${({ $placement }) => ($placement === 'center' ? '50%' : '0.75rem')};
  transform: ${({ $placement }) =>
    $placement === 'center' ? 'translateX(-50%)' : 'none'};
  z-index: 20;
  max-width: calc(100% - 1.5rem);
  background: var(--popover);
  color: var(--popover-foreground);
`

export function GraphStatus({
  message,
  failed,
  retry,
  placement = 'start',
  role = 'status',
}: {
  message: string
  failed: boolean
  retry: () => void
  placement?: StatusPlacement
  role?: 'status' | 'alert'
}): ReactElement {
  return (
    <Status
      role={role}
      $placement={placement}
      display='flex'
      align='center'
      gap='sm'
      paddingX='md'
      paddingY='sm'
      radius='md'
      border='default'>
      <Text variant='body' color='inherit'>
        {message}
      </Text>
      {failed && (
        <Button variant='ghost' size='sm' onClick={retry}>
          <Trans>Retry</Trans>
        </Button>
      )}
    </Status>
  )
}
